export function formatCalendarDayAriaLabel(date) {
  return date.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
}

function dayToneClasses({ inMonth, isToday }) {
  const classes = [inMonth ? "bg-white hover:bg-gray-50" : "bg-gray-50 hover:bg-gray-100"];
  if (isToday) classes.push("font-semibold");
  else classes.push(inMonth ? "text-gray-900" : "text-gray-400");
  return classes;
}

function monthCornerClass(dayIdx, totalDays) {
  if (dayIdx === 0) return "rounded-tl-lg";
  if (dayIdx === 6) return "rounded-tr-lg";
  if (dayIdx === totalDays - 7) return "rounded-bl-lg";
  if (dayIdx === totalDays - 1) return "rounded-br-lg";
  return "";
}

export function getMonthDayCellClasses({ inMonth, isToday, dayIdx, totalDays }) {
  return [
    "relative h-16 w-full cursor-pointer py-2 transition-colors outline-none focus:outline-none",
    ...dayToneClasses({ inMonth, isToday }),
    monthCornerClass(dayIdx, totalDays),
  ]
    .filter(Boolean)
    .join(" ");
}

export function getCompactDayCellClasses({ inMonth, isToday, hasAssessments, sizingClass }) {
  const tone = dayToneClasses({ inMonth, isToday });
  if (!inMonth) tone[0] = "bg-gray-50/80 hover:bg-gray-100";
  return [
    "relative flex w-full flex-col items-center cursor-pointer transition-colors outline-none focus:outline-none",
    sizingClass,
    hasAssessments ? "justify-between pt-0.5 pb-1.5" : "justify-center",
    ...tone,
  ]
    .filter(Boolean)
    .join(" ");
}
